/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ConversationalAgentGenerationInputs,
  ConversationalAgentGenerationInputsCreate,
  GenerationInputsPolymorphic,
  InformationExtractionGenerationInputs,
  InformationExtractionGenerationInputsCreate,
  PaginatedConversationalAgentGenerationInputsList,
  PaginatedGenerationInputsPolymorphicList,
  PaginatedInformationExtractionGenerationInputsList,
  PaginatedSingleTurnChatGenerationInputsList,
  PaginatedVoiceAgentGenerationInputsList,
  SingleTurnChatGenerationInputs,
  SingleTurnChatGenerationInputsCreate,
  SingleTurnChatGenerationKnowledgeBase,
  SingleTurnChatGenerationKnowledgeBaseFile,
  VoiceAgentGenerationInputs,
  VoiceAgentGenerationInputsCreate,
} from '../models/index';
import {
  ConversationalAgentGenerationInputsFromJSON,
  ConversationalAgentGenerationInputsToJSON,
  ConversationalAgentGenerationInputsCreateFromJSON,
  ConversationalAgentGenerationInputsCreateToJSON,
  GenerationInputsPolymorphicFromJSON,
  GenerationInputsPolymorphicToJSON,
  InformationExtractionGenerationInputsFromJSON,
  InformationExtractionGenerationInputsToJSON,
  InformationExtractionGenerationInputsCreateFromJSON,
  InformationExtractionGenerationInputsCreateToJSON,
  PaginatedConversationalAgentGenerationInputsListFromJSON,
  PaginatedConversationalAgentGenerationInputsListToJSON,
  PaginatedGenerationInputsPolymorphicListFromJSON,
  PaginatedGenerationInputsPolymorphicListToJSON,
  PaginatedInformationExtractionGenerationInputsListFromJSON,
  PaginatedInformationExtractionGenerationInputsListToJSON,
  PaginatedSingleTurnChatGenerationInputsListFromJSON,
  PaginatedSingleTurnChatGenerationInputsListToJSON,
  PaginatedVoiceAgentGenerationInputsListFromJSON,
  PaginatedVoiceAgentGenerationInputsListToJSON,
  SingleTurnChatGenerationInputsFromJSON,
  SingleTurnChatGenerationInputsToJSON,
  SingleTurnChatGenerationInputsCreateFromJSON,
  SingleTurnChatGenerationInputsCreateToJSON,
  SingleTurnChatGenerationKnowledgeBaseFromJSON,
  SingleTurnChatGenerationKnowledgeBaseToJSON,
  SingleTurnChatGenerationKnowledgeBaseFileFromJSON,
  SingleTurnChatGenerationKnowledgeBaseFileToJSON,
  VoiceAgentGenerationInputsFromJSON,
  VoiceAgentGenerationInputsToJSON,
  VoiceAgentGenerationInputsCreateFromJSON,
  VoiceAgentGenerationInputsCreateToJSON,
} from '../models/index';

export interface ApiDataGenerationInputsConversationalAgentCreateRequest {
  conversationalAgentGenerationInputsCreate: ConversationalAgentGenerationInputsCreate;
}

export interface ApiDataGenerationInputsConversationalAgentListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDataGenerationInputsConversationalAgentRetrieveRequest {
  id: number;
}

export interface ApiDataGenerationInputsInformationExtractionCreateRequest {
  informationExtractionGenerationInputsCreate: Omit<InformationExtractionGenerationInputsCreate, 'id'>;
}

export interface ApiDataGenerationInputsInformationExtractionListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDataGenerationInputsInformationExtractionRetrieveRequest {
  id: number;
}

export interface ApiDataGenerationInputsListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDataGenerationInputsRetrieveRequest {
  id: number;
}

export interface ApiDataGenerationInputsSingleTurnChatCreateRequest {
  singleTurnChatGenerationInputsCreate: SingleTurnChatGenerationInputsCreate;
}

export interface ApiDataGenerationInputsSingleTurnChatKnowledgebaseCreateRequest {
  singleTurnChatGenerationKnowledgeBase?: Omit<SingleTurnChatGenerationKnowledgeBase, 'id' | 'files'>;
}

export interface ApiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreateRequest {
  knowledgeBase: number;
  file: Blob;
}

export interface ApiDataGenerationInputsSingleTurnChatListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDataGenerationInputsSingleTurnChatRetrieveRequest {
  id: number;
}

export interface ApiDataGenerationInputsVoiceAgentCreateRequest {
  voiceAgentGenerationInputsCreate: VoiceAgentGenerationInputsCreate;
}

export interface ApiDataGenerationInputsVoiceAgentListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiDataGenerationInputsVoiceAgentRetrieveRequest {
  id: number;
}

/**
 *
 */
export class GenerationInputsApi extends runtime.BaseAPI {
  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentCreateRaw(
    requestParameters: ApiDataGenerationInputsConversationalAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentGenerationInputs>> {
    if (requestParameters['conversationalAgentGenerationInputsCreate'] == null) {
      throw new runtime.RequiredError(
        'conversationalAgentGenerationInputsCreate',
        'Required parameter "conversationalAgentGenerationInputsCreate" was null or undefined when calling apiDataGenerationInputsConversationalAgentCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/conversational-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: ConversationalAgentGenerationInputsCreateToJSON(
          requestParameters['conversationalAgentGenerationInputsCreate'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentCreate(
    requestParameters: ApiDataGenerationInputsConversationalAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentGenerationInputs> {
    const response = await this.apiDataGenerationInputsConversationalAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentListRaw(
    requestParameters: ApiDataGenerationInputsConversationalAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedConversationalAgentGenerationInputsList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/conversational-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedConversationalAgentGenerationInputsListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentList(
    requestParameters: ApiDataGenerationInputsConversationalAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedConversationalAgentGenerationInputsList> {
    const response = await this.apiDataGenerationInputsConversationalAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentRetrieveRaw(
    requestParameters: ApiDataGenerationInputsConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ConversationalAgentGenerationInputs>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDataGenerationInputsConversationalAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/conversational-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => ConversationalAgentGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for Conversational Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsConversationalAgentRetrieve(
    requestParameters: ApiDataGenerationInputsConversationalAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ConversationalAgentGenerationInputs> {
    const response = await this.apiDataGenerationInputsConversationalAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionCreateRaw(
    requestParameters: ApiDataGenerationInputsInformationExtractionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InformationExtractionGenerationInputsCreate>> {
    if (requestParameters['informationExtractionGenerationInputsCreate'] == null) {
      throw new runtime.RequiredError(
        'informationExtractionGenerationInputsCreate',
        'Required parameter "informationExtractionGenerationInputsCreate" was null or undefined when calling apiDataGenerationInputsInformationExtractionCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/information-extraction/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: InformationExtractionGenerationInputsCreateToJSON(
          requestParameters['informationExtractionGenerationInputsCreate'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      InformationExtractionGenerationInputsCreateFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionCreate(
    requestParameters: ApiDataGenerationInputsInformationExtractionCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InformationExtractionGenerationInputsCreate> {
    const response = await this.apiDataGenerationInputsInformationExtractionCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionListRaw(
    requestParameters: ApiDataGenerationInputsInformationExtractionListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedInformationExtractionGenerationInputsList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/information-extraction/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedInformationExtractionGenerationInputsListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionList(
    requestParameters: ApiDataGenerationInputsInformationExtractionListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedInformationExtractionGenerationInputsList> {
    const response = await this.apiDataGenerationInputsInformationExtractionListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionRetrieveRaw(
    requestParameters: ApiDataGenerationInputsInformationExtractionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<InformationExtractionGenerationInputs>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDataGenerationInputsInformationExtractionRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/information-extraction/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => InformationExtractionGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for InformationExtraction Generation Inputs operations.
   */
  async apiDataGenerationInputsInformationExtractionRetrieve(
    requestParameters: ApiDataGenerationInputsInformationExtractionRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<InformationExtractionGenerationInputs> {
    const response = await this.apiDataGenerationInputsInformationExtractionRetrieveRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * API endpoint for Generation Inputs operations.
   */
  async apiDataGenerationInputsListRaw(
    requestParameters: ApiDataGenerationInputsListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedGenerationInputsPolymorphicList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedGenerationInputsPolymorphicListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for Generation Inputs operations.
   */
  async apiDataGenerationInputsList(
    requestParameters: ApiDataGenerationInputsListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedGenerationInputsPolymorphicList> {
    const response = await this.apiDataGenerationInputsListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Generation Inputs operations.
   */
  async apiDataGenerationInputsRetrieveRaw(
    requestParameters: ApiDataGenerationInputsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<GenerationInputsPolymorphic>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDataGenerationInputsRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => GenerationInputsPolymorphicFromJSON(jsonValue));
  }

  /**
   * API endpoint for Generation Inputs operations.
   */
  async apiDataGenerationInputsRetrieve(
    requestParameters: ApiDataGenerationInputsRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<GenerationInputsPolymorphic> {
    const response = await this.apiDataGenerationInputsRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatCreateRaw(
    requestParameters: ApiDataGenerationInputsSingleTurnChatCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatGenerationInputs>> {
    if (requestParameters['singleTurnChatGenerationInputsCreate'] == null) {
      throw new runtime.RequiredError(
        'singleTurnChatGenerationInputsCreate',
        'Required parameter "singleTurnChatGenerationInputsCreate" was null or undefined when calling apiDataGenerationInputsSingleTurnChatCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/single-turn-chat/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SingleTurnChatGenerationInputsCreateToJSON(requestParameters['singleTurnChatGenerationInputsCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatCreate(
    requestParameters: ApiDataGenerationInputsSingleTurnChatCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatGenerationInputs> {
    const response = await this.apiDataGenerationInputsSingleTurnChatCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiDataGenerationInputsSingleTurnChatKnowledgebaseCreateRaw(
    requestParameters: ApiDataGenerationInputsSingleTurnChatKnowledgebaseCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatGenerationKnowledgeBase>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/single-turn-chat/knowledgebase/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: SingleTurnChatGenerationKnowledgeBaseToJSON(requestParameters['singleTurnChatGenerationKnowledgeBase']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatGenerationKnowledgeBaseFromJSON(jsonValue));
  }

  /**
   */
  async apiDataGenerationInputsSingleTurnChatKnowledgebaseCreate(
    requestParameters: ApiDataGenerationInputsSingleTurnChatKnowledgebaseCreateRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatGenerationKnowledgeBase> {
    const response = await this.apiDataGenerationInputsSingleTurnChatKnowledgebaseCreateRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async apiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreateRaw(
    requestParameters: ApiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatGenerationKnowledgeBaseFile>> {
    if (requestParameters['knowledgeBase'] == null) {
      throw new runtime.RequiredError(
        'knowledgeBase',
        'Required parameter "knowledgeBase" was null or undefined when calling apiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreate().',
      );
    }

    if (requestParameters['file'] == null) {
      throw new runtime.RequiredError(
        'file',
        'Required parameter "file" was null or undefined when calling apiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const consumes: runtime.Consume[] = [
      { contentType: 'multipart/form-data' },
      { contentType: 'application/x-www-form-urlencoded' },
    ];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters['knowledgeBase'] != null) {
      formParams.append('knowledge_base', requestParameters['knowledgeBase'] as any);
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any);
    }

    const response = await this.request(
      {
        path: `/api/data-generation-inputs/single-turn-chat/knowledgebase/file/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      SingleTurnChatGenerationKnowledgeBaseFileFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreate(
    requestParameters: ApiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatGenerationKnowledgeBaseFile> {
    const response = await this.apiDataGenerationInputsSingleTurnChatKnowledgebaseFileCreateRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatListRaw(
    requestParameters: ApiDataGenerationInputsSingleTurnChatListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedSingleTurnChatGenerationInputsList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/single-turn-chat/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedSingleTurnChatGenerationInputsListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatList(
    requestParameters: ApiDataGenerationInputsSingleTurnChatListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedSingleTurnChatGenerationInputsList> {
    const response = await this.apiDataGenerationInputsSingleTurnChatListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatRetrieveRaw(
    requestParameters: ApiDataGenerationInputsSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SingleTurnChatGenerationInputs>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDataGenerationInputsSingleTurnChatRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/single-turn-chat/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => SingleTurnChatGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for single-turn-chat generation inputs operations.
   */
  async apiDataGenerationInputsSingleTurnChatRetrieve(
    requestParameters: ApiDataGenerationInputsSingleTurnChatRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SingleTurnChatGenerationInputs> {
    const response = await this.apiDataGenerationInputsSingleTurnChatRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentCreateRaw(
    requestParameters: ApiDataGenerationInputsVoiceAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentGenerationInputs>> {
    if (requestParameters['voiceAgentGenerationInputsCreate'] == null) {
      throw new runtime.RequiredError(
        'voiceAgentGenerationInputsCreate',
        'Required parameter "voiceAgentGenerationInputsCreate" was null or undefined when calling apiDataGenerationInputsVoiceAgentCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/voice-agent/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: VoiceAgentGenerationInputsCreateToJSON(requestParameters['voiceAgentGenerationInputsCreate']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentCreate(
    requestParameters: ApiDataGenerationInputsVoiceAgentCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentGenerationInputs> {
    const response = await this.apiDataGenerationInputsVoiceAgentCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentListRaw(
    requestParameters: ApiDataGenerationInputsVoiceAgentListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedVoiceAgentGenerationInputsList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/voice-agent/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedVoiceAgentGenerationInputsListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentList(
    requestParameters: ApiDataGenerationInputsVoiceAgentListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedVoiceAgentGenerationInputsList> {
    const response = await this.apiDataGenerationInputsVoiceAgentListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentRetrieveRaw(
    requestParameters: ApiDataGenerationInputsVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VoiceAgentGenerationInputs>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiDataGenerationInputsVoiceAgentRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/data-generation-inputs/voice-agent/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => VoiceAgentGenerationInputsFromJSON(jsonValue));
  }

  /**
   * API endpoint for Voice Agent Generation Inputs operations.
   */
  async apiDataGenerationInputsVoiceAgentRetrieve(
    requestParameters: ApiDataGenerationInputsVoiceAgentRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VoiceAgentGenerationInputs> {
    const response = await this.apiDataGenerationInputsVoiceAgentRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
